import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.module.scss'

const TabsHeader = ({
  headings,
  selectedTab,
  onTabHeadingClick,
  fullWidth,
  disabledTabVal,
}) => {
  const iconType = heading => {
    if (heading === 'Nearby') {
      return 'location-drop-pin'
    }
    if (heading === 'All centres') {
      return 'list-view'
    } else {
      return null
    }
  }
  return (
    <div className={fullWidth ? style.tabBarFull : style.tabBar}>
      <ul
        id="container"
        className={
          fullWidth ? style.tabHeaderFull : classNames(style.tabHeader)
        }
        role="tablist"
      >
        {headings.map((heading, i) => (
          <li key={`tabHeading${i}`} role="presentation">
            {iconType(heading) && (
              <Icon
                className={classNames(style.tabIcon, {
                  [style.tabIconDisabled]: disabledTabVal === heading,
                })}
                type={iconType(heading)}
              />
            )}
            <button
              data-test-id="tab-button"
              className={classNames(
                fullWidth ? style.tabTitleFull : style.tabTitle,
                {
                  [style.activeTabTitle]: selectedTab === i,
                }
              )}
              disabled={disabledTabVal === heading}
              aria-controls={`tabpanel${i}`}
              aria-selected={selectedTab === i}
              role="tab"
              index={i}
              onClick={onTabHeadingClick}
            >
              {heading}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

TabsHeader.propTypes = {
  selectedTab: PropTypes.number,
  headings: PropTypes.arrayOf(PropTypes.string),
  onTabHeadingClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  disabledTabVal: PropTypes.string,
}

TabsHeader.defaultProps = {
  fullWidth: false,
}

export default TabsHeader
